import { defineStore } from 'pinia'
import {
  modelCollectionState,
  modelCollectionActions,
  modelCollectionGetters,
} from '@app/stores/ModelCollectionStore'

export const useCaseStudyStore = defineStore('CaseStudyStore', {
  state: () => {
    return { ...modelCollectionState('caseStudies') }
  },
  getters: { ...modelCollectionGetters('caseStudies', 'caseStudy') },
  actions: {
    ...modelCollectionActions('caseStudies', 'caseStudy'),
    updateSections(updatedCaseStudy) {
      const current = this.caseStudies.find((c) => c.id == updatedCaseStudy.id)
      // NOTE: we can't use the standard upsertCaseStudy or replaceCaseStudies
      // from ModelCollectionStore, that'll break reactivity since we're dealing with
      // an array within an object
      current.sections = updatedCaseStudy.sections
    },
    async createSection(caseStudyId, type, section) {
      return this.api.createCaseStudySection(caseStudyId, type, section).then((response) => {
        this.updateSections(response.data.case_study)
      })
    },
    async deleteSection(caseStudyId, sectionIndex) {
      return this.api.deleteCaseStudySection(caseStudyId, sectionIndex).then((response) => {
        this.updateSections(response.data.case_study)
      })
    },
    async moveSection(caseStudyId, sectionIndex, forward) {
      return this.api.moveCaseStudySection(caseStudyId, sectionIndex, forward).then((response) => {
        this.updateSections(response.data.case_study)
      })
    },
    async updateSection(caseStudyId, sectionIndex, section) {
      return this.api
        .updateCaseStudySection(caseStudyId, sectionIndex, section)
        .then((response) => {
          this.updateSections(response.data.case_study)
        })
    },
    async removeHeaderImage(caseStudyId) {
      return this.api.removeCaseStudyHeaderImage(caseStudyId)
    },
    async removeCustomerLogo(caseStudyId) {
      return this.api.removeCaseStudyCustomerLogo(caseStudyId)
    },
  },
})
